<template>
    <component :is="leaderboardComponent"></component>
</template>
<script>
import LeaderBoardNormal from './LeaderBoardNormal.vue';
import LeaderBoardContest from './LeaderBoardContest.vue';
export default {
    name: 'Leaderboard',
    computed: {
        leaderboardComponent() {
            const contest = this.$store.state.user_info?.contest_info;
            if (!contest?.id) return LeaderBoardNormal;

            const now = moment();
            const start = moment.parseZone(contest.start_time, moment.ISO_8601, true);
            const end = moment.parseZone(contest.end_time, moment.ISO_8601, true);

            // Nếu thời gian không hợp lệ -> fallback
            if (!start.isValid() || !end.isValid()) {
                return LeaderBoardNormal;
            }

            // 1) Đang trong thời gian diễn ra contest (bao gồm biên)
            const inContest = now.isBetween(start, end, undefined, '[]');
            if (inContest) {
                return LeaderBoardContest;
            }

            // 2) Sau contest: kiểm tra quyền hiển thị & khoảng gia hạn
            const afterFlag = Number(contest.show_leaderboard_after_contest) === 1;
            if (!afterFlag) {
                return LeaderBoardNormal;
            }

            // Số ngày gia hạn sau khi kết thúc (mặc định 0 nếu falsy)
            const limitDays = Number.isFinite(Number(contest.limit_show_leaderboard_after_contest))
                ? Number(contest.limit_show_leaderboard_after_contest)
                : 0;

            // Nếu limitDays < 0 -> coi như 0 cho an toàn
            const safeLimitDays = Math.max(0, limitDays);

            // Mốc kết thúc được phép hiển thị leaderboard contest
            const endWithGrace = end.clone().add(safeLimitDays, 'days');

            // Nếu đang trong khoảng (end_time, end_time + limitDays] (bao gồm biên phải)
            const inAfterWindow = now.isAfter(end) && now.isSameOrBefore(endWithGrace);
            if (inAfterWindow) {
                return LeaderBoardContest;
            }

            // 3) Hết hạn -> bình thường
            return LeaderBoardNormal;
        }
    }
}
</script>